export const BASE_URLS = {
  PRODUCTION: "https://vendas.grupoatem.com.br/#/road-scheduling",
  DEVELOPMENT: "https://vendas-dev.grupoatem.com.br/#/road-scheduling",
  LOCALHOST: "http://localhost:5173/#/road-scheduling",
};
